import {kSystemIcons} from "../../../constants/icons";

export default function GamesTimerIcon() {
    // Used in GamesLeaveButton to display cancel
    // icon for leaving the game before the end

    // BUILD
    return (
        <div className={"w-[20px] min-w-[20px] max-w-[20px] flex justify-center pt-[2px]"}>
            <i className={"material-icons text-[22px] text-timerBlue"}>
                {kSystemIcons.timer}
            </i>
        </div>
    );
}